var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"product-amount-mode"},[_c('p',{staticClass:"product-amount-mode__text",domProps:{"innerHTML":_vm._s(_vm.description)}}),_c('ButtonLink',{on:{"click":function($event){return _vm.$emit('switch')}}},[_vm._v(_vm._s(_vm.linkLabel))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }